var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skills"},[_c('h5',{staticClass:"title"},[_vm._v("Vaardigheden")]),_vm._v(" "),_c('ul',{staticClass:"skills-list"},_vm._l((_vm.skillsIn),function(skill){return _c('li',{key:skill.id,staticClass:"skill"},[_c('design-2021-workflow-show-skill-progress-component',{attrs:{"skill-in":skill}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }